// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `app-root .validation-wrapper {
  display: block;
  font-size: 1rem;
  position: relative;
}
app-root .validation-wrapper.show-validity select:invalid,
app-root .validation-wrapper.show-validity input:invalid {
  border-color: #f5222d;
  outline-color: #f5222d;
}
app-root .validation-wrapper.show-validity select:invalid:hover,
app-root .validation-wrapper.show-validity input:invalid:hover {
  outline-color: #f5222d;
  border-color: #f5222d;
  box-shadow: 0 0 0 2px rgba(232, 132, 132, 0.28);
}
app-root .validation-wrapper.show-validity select:invalid:focus,
app-root .validation-wrapper.show-validity input:invalid:focus {
  outline-color: #f5222d;
  border-color: #f5222d;
  box-shadow: 0 0 0 3px rgba(232, 132, 132, 0.28);
}
app-root .validation-wrapper.show-validity .radio-button input:invalid,
app-root .validation-wrapper.show-validity .checkbox-button input:invalid {
  outline-color: unset;
}
app-root .validation-wrapper.show-validity .radio-button input:invalid + label,
app-root .validation-wrapper.show-validity .checkbox-button input:invalid + label {
  border-color: #f5222d;
  outline-color: #f5222d;
}
app-root .validation-wrapper.show-validity .radio-button input:invalid input:focus,
app-root .validation-wrapper.show-validity .checkbox-button input:invalid input:focus {
  box-shadow: unset;
}
app-root .validation-wrapper.show-validity .radio-button input:invalid input:focus + label,
app-root .validation-wrapper.show-validity .checkbox-button input:invalid input:focus + label {
  box-shadow: 0 0 0 3px rgba(232, 132, 132, 0.28);
}
app-root .validation-wrapper .error-message {
  display: block;
  position: relative;
  z-index: -1;
  font-size: 0.875rem;
  font-weight: 500;
  padding-top: 0.1rem;
  min-height: 1.6rem;
  opacity: 0;
  will-change: transform, opacity;
  transform: translateY(-0.8rem);
  transition: transform 0.3s cubic-bezier(0.215, 0.61, 0.355, 1), opacity 0.3s cubic-bezier(0.215, 0.61, 0.355, 1) 0.05s;
}
app-root .validation-wrapper.show-validity .error-message {
  z-index: unset;
  transform: translateY(0);
  opacity: 1;
  color: #f5222d;
}
`, "",{"version":3,"sources":["webpack://./src/Components/Form/Inputs/ValidationMessage/ValidationMessage.less"],"names":[],"mappings":"AAEA;EAEI,cAAA;EACA,eAAA;EACA,kBAAA;AAFJ;AAII;;EAGI,qBAAA;EACA,sBAAA;AAHR;AAKQ;;EACE,sBAAA;EACA,qBAAA;EACA,+CAAA;AAFV;AAIQ;;EACE,sBAAA;EACA,qBAAA;EACA,+CAAA;AADV;AAbI;;EAqBM,oBAAA;AAJV;AAMU;;EACE,qBAAA;EACA,sBAAA;AAHZ;AAtBI;;EA6BQ,iBAAA;AAHZ;AAKY;;EACE,+CAAA;AAFd;AApCA;EA8CM,cAAA;EACA,kBAAA;EACA,WAAA;EACA,mBAAA;EACA,gBAAA;EACA,mBAAA;EACA,kBAAA;EACA,UAAA;EACA,+BAAA;EACA,8BAAA;EACA,sHAAA;AAPN;AAWI;EACE,cAAA;EACA,wBAAA;EACA,UAAA;EACA,cAAA;AATN","sourcesContent":["@import '../../../../Styles/colours.less';\n\napp-root {\n  .validation-wrapper {\n    display: block;\n    font-size: 1rem;\n    position: relative;\n\n    &.show-validity {\n      select:invalid,\n      input:invalid {\n        border-color: @error-red;\n        outline-color: @error-red;\n\n        &:hover {\n          outline-color: @error-red;\n          border-color: @error-red;\n          box-shadow: 0 0 0 2px rgb(232 132 132 / 28%);\n        }\n        &:focus {\n          outline-color: @error-red;\n          border-color: @error-red;\n          box-shadow: 0 0 0 3px rgb(232 132 132 / 28%);\n        }\n      }\n\n      .radio-button,\n      .checkbox-button {\n        input:invalid {\n          outline-color: unset;\n\n          & + label {\n            border-color: @error-red;\n            outline-color: @error-red;\n          }\n\n          input:focus {\n            box-shadow: unset;\n\n            & + label {\n              box-shadow: 0 0 0 3px rgb(232 132 132 / 28%);\n            }\n          }\n        }\n      }\n    }\n\n    .error-message {\n      display: block;\n      position: relative;\n      z-index: -1; // ensures child inputs not partially blocked by displaced message container\n      font-size: 0.875rem;\n      font-weight: 500;\n      padding-top: 0.1rem;\n      min-height: 1.6rem; // line-height plus padding\n      opacity: 0;\n      will-change: transform, opacity;\n      transform: translateY(-0.8rem);\n      transition: transform 0.3s cubic-bezier(0.215, 0.61, 0.355, 1),\n        opacity 0.3s cubic-bezier(0.215, 0.61, 0.355, 1) 0.05s;\n    }\n\n    &.show-validity .error-message {\n      z-index: unset;\n      transform: translateY(0);\n      opacity: 1;\n      color: @error-red;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
